module.exports = __webpack_public_path__ + "fonts/icomoon.4f0044560002ad9fc91bf3768abf1dfd.eot";